import { MetadataType } from '../enums/enums'
import { QuestionData } from '../models/global.types'

export function getMcqPart (question: QuestionData): number | null {
  if (question === undefined) { return null }
  if (question.metadata === undefined || question.metadata.length === 0) { return null }

  for (const meta of question.metadata) {
    if (meta.name === MetadataType.QuestionMcqPart) {
      const value = parseInt(meta.value)
      if (isNaN(value)) { return null }
      return value
    }
  }

  return null
}

export function getVideoTimestamp (question: QuestionData): number | null {
  if (question === undefined) { return null }
  if (question.metadata === undefined || question.metadata.length === 0) { return null }

  for (const meta of question.metadata) {
    if (meta.name === MetadataType.QuestionVideoTimestamp) {
      const value = parseFloat(meta.value)
      if (isNaN(value)) { return null }
      return value
    }
  }

  return null
}

export function getVideoTimestampEad (question: QuestionData): number | null {
  if (question === undefined) { return null }
  if (question.metadata === undefined || question.metadata.length === 0) { return null }

  for (const meta of question.metadata) {
    if (meta.name === MetadataType.QuestionVideoTimestampEad) {
      const value = parseFloat(meta.value)
      if (isNaN(value)) { return null }
      return value
    }
  }

  return null
}

/**
 * Gets the appropriate video timestamp based on whether EAD (Enhanced Audio Description) is enabled.
 * If EAD is enabled and an EAD timestamp exists, returns the EAD timestamp.
 * Otherwise, returns the regular video timestamp.
 */
export function getVideoTimestampForEadPreference (question: QuestionData, isEadEnabled: boolean): number | null {
  if (isEadEnabled) {
    const eadTimestamp = getVideoTimestampEad(question)
    if (eadTimestamp !== null) {
      return eadTimestamp
    }
  }

  return getVideoTimestamp(question)
}

const newMetadata = {
  id: 'backwardsCompatibleMcqPartMetadata',
  name: MetadataType.QuestionMcqPart,
  value: '1'
}

/**
 * Checks if the question has part metadata set, and if not, sets it as part 1.
 * Done for backwards compatibility.
 */
export function ensureMcqPartMetadata (question: QuestionData): void {
  if (question.metadata === undefined) {
    question.metadata = [newMetadata]
  } else if (getMcqPart(question) === null) {
    question.metadata.push(newMetadata)
  }
}
